<div class="mx-auto max-w-(--breakpoint-2xl) space-y-4">
  <div class="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
    <div class="space-y-1">
      <p class="text-sm font-medium text-gray-500">Lead capture</p>
      <h1 class="text-2xl font-semibold text-gray-900">Quotes</h1>
      <p class="text-sm text-gray-500">View and triage submitted venue quotes.</p>
    </div>
    <div class="flex w-full flex-col gap-2 sm:w-auto sm:flex-row sm:items-center">
      @if (exportEnabled) {
        <app-button
          [label]="exporting ? 'Exporting…' : 'Export CSV'"
          [icon]="DownloadIcon"
          [style]="'secondary'"
          [disabled]="exporting"
          (click)="exportCsv()"
        ></app-button>
      }
      <div class="w-full sm:w-80">
        <app-text-input
          [control]="searchControl"
          [placeholder]="'Search by contact or email'"
          [clearable]="true"
        ></app-text-input>
      </div>
    </div>
  </div>

  <app-data-table
    [dataPage]="quotesPage"
    [columns]="tableColumns"
    [rowActions]="rowActions"
    [rowRouterLinkTemplate]="'/quotes/:id'"
    (route)="handleRoute($event)"
  ></app-data-table>
</div>
